function PasswordChanger($el)
{
    this.$el = $el;

    this.events();
}

PasswordChanger.prototype.events = function()
{
    var self = this;

    this.$el.on('click', '.btn-change-pw', function(){
        if(self.$el.find('.pw-change-container').is(':visible')) {
            self.$el.find('.pw-change-container').slideUp();
        } else {
            self.$el.find('.pw-change-container').slideDown();
        }
    });
}


$(document).ready(function(){
    var $userEditForm = $('.user-edit-form-container');

    if($userEditForm.length == 1)
        new PasswordChanger($userEditForm);
});